export type ID = { readonly id: string };
export namespace ID {
  export const from = (value: string | number): ID =>
    typeof value === "string" ? fromString(value) : fromNumber(value);

  export const fromString = (string: string): ID => ({ id: string });
  export const fromNumber = (number: number): ID => fromString(`${number}`);
}
